import { motion } from "framer-motion";
const ProcessingLoader = ({ isProcessing, progress }) => {
    if (!isProcessing) return null;
    return (
        <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="absolute inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50"
      >
        <div className="bg-white p-6 rounded-lg shadow-xl w-96">
          <motion.div
            className="w-full h-2 bg-gray-200 rounded-full overflow-hidden"
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{ duration: 0.5 }}
          >
            <motion.div
              className="h-full bg-gradient-to-r from-[#25D366] to-[#128C7E]"
              style={{ width: `${progress}%` }}
              transition={{ duration: 0.3 }}
            />
          </motion.div>
          <p className="text-center mt-4 text-gray-700 font-semibold">
            Processing... {Math.round(progress)}%
          </p>
        </div>
      </motion.div>
    );
  };
  
  export default ProcessingLoader;
  